import React from 'react';
import styled from 'styled-components';
import { Radio as AntdRadio } from 'antd';
import {
  RadioGroupProps as AntdRadioGroupProps,
  RadioProps as AntdRadioProps,
} from 'antd/lib/radio';
import { RadioButtonProps as AntdRadioButtonProps } from 'antd/lib/radio/radioButton';
import LabelWrapper from '../LabelWrapper';
import Icon from '../Icon';
import {
  StyledRadioWrapper,
  StyledClearButtonWrapper,
} from './StyledComponents';

export type RadioGroupProps = AntdRadioGroupProps & {
  label?: React.ReactText;
  error?: string | boolean;
  required?: boolean;
  allowClear?: boolean;
  buttonJustify?: 'center';
  dataCy?: string;
  fullWidth?: boolean;
};

export type RadioButtonProps = AntdRadioButtonProps;

export const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  error,
  required,
  allowClear,
  buttonJustify,
  dataCy,
  fullWidth,
  value,
  onChange,
  className,
  children,
  ...props
}) => {
  const clear = () => {
    if (!allowClear) return false;
    onChange({
      target: {
        checked: undefined,
        value: undefined,
      },
      stopPropagation: () => null,
      preventDefault: () => null,
      nativeEvent: undefined,
    });
  };
  const canShowClearButton = () => {
    if (!allowClear) return false;
    return value !== undefined && value !== null;
  };

  return (
    <LabelWrapper
      label={label}
      error={error}
      required={required}
      className={className}
    >
      <StyledRadioWrapper
        $showButton={canShowClearButton()}
        $justify={buttonJustify}
        $fullWidth={fullWidth}
        data-cy={dataCy}
      >
        <AntdRadio.Group
          {...props}
          onChange={onChange as AntdRadioGroupProps['onChange']}
          value={value}
        >
          {children}
        </AntdRadio.Group>
        <StyledClearButtonWrapper $showButton={canShowClearButton()}>
          <button onClick={clear}>
            <Icon type="x" color="white" width={12} height={12} />
          </button>
        </StyledClearButtonWrapper>
      </StyledRadioWrapper>
    </LabelWrapper>
  );
};

export const RadioButton = styled((props: AntdRadioButtonProps) => <AntdRadio.Button {...props} />)``;

export const Radio = styled((props: AntdRadioProps) => <AntdRadio {...props} />)``;

export default styled(RadioGroup)``;
